/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index date-format to autogenerate all the components and extensions
 * Used by "prepareDateFormats"
 */

import DateFormat from './date-format/DateFormat'
export * from './date-format/DateFormat'
export default DateFormat
